export const APP_CONFIG: any = {
  topNav: {
    C: [
      { group: 'COMPANY', items: [
        { label: 'Create', hotkey: 'C' },
        { label: 'Alter', hotkey: 'A' },
        { label: 'Select', hotkey: 'S', shortcut: 'F3' },
        { label: 'Delete', hotkey: 'D' },
      ]},
      { group: 'DATA', items: [
        { label: 'Backup', hotkey: 'B' },
        { label: 'Restore', hotkey: 'R' },
      ]},
      { group: 'SETTINGS', items: [
        { label: 'Customization', hotkey: 'U' },
        { label: 'License & Setup', hotkey: 'L' },
      ]}
    ],
    Y: [
      { group: 'DATA', items: [
        { label: 'Backup', hotkey: 'B' },
        { label: 'Restore', hotkey: 'R' }
      ]},
      { group: 'LICENSE', items: [
        { label: 'License & Setup', hotkey: 'L' }
      ]}
    ],
    O: [{ items: [{ label: 'Bank Transactions Import', hotkey: 'B' }, { label: 'Invoice Import', hotkey: 'I' }] }],
    E: [{ items: [{ label: 'Excel', hotkey: 'E' }, { label: 'PDF', hotkey: 'P' }] }],
    P: [{ items: [{ label: 'Current', hotkey: 'C' }, { label: 'Configuration', hotkey: 'O' }] }],
    G: [
      { group: 'GST RETURNS', items: [
        { label: 'GSTR-1 (Outward Supplies)', hotkey: 'G' },
        { label: 'GSTR-3B (Summary Return)',  hotkey: '3' },
        { label: 'GST Tax Rate Summary',      hotkey: 'T' },
      ]},
      { group: 'e-INVOICE', items: [
        { label: 'Generate e-Invoice JSON', hotkey: 'E' },
      ]},
    ],
    Q: [{ items: [{ label: 'Ledgers', hotkey: 'L' }, { label: 'Registers', hotkey: 'R' }] }],
  },
  gatewayMenus: {
    main: [
      { group: 'MASTERS', items: [
          { name: 'Master Creation', hotkeyIdx: 0 },
          { name: 'Master Alteration', hotkeyIdx: 1 },
          { name: 'Accounts List', hotkeyIdx: 1 }
        ] },
      { group: 'TRANSACTIONS', items: [
          { name: 'Vouchers', hotkeyIdx: 0 },
          { name: 'Quotations', hotkeyIdx: 0 },
          { name: 'Day Book', hotkeyIdx: 0 },
          { name: 'Ledgers', hotkeyIdx: 0 }
        ] },
      { group: 'HR & PAYROLL', items: [
          { name: 'Employees', hotkeyIdx: 0 },
          { name: 'Payroll', hotkeyIdx: 0 }
        ] },
      { group: 'REPORTS', items: [
          { name: 'Business Overview', hotkeyIdx: 0 },
          { name: 'Balance Sheet', hotkeyIdx: 4 },
          { name: 'Profit & Loss A/c', hotkeyIdx: 1 },
          { name: 'Stock Overview', hotkeyIdx: 0 },
          { name: 'Ratio Analysis', hotkeyIdx: 2 },
          { name: 'Display All Reports', hotkeyIdx: 1 }
        ] },
      { group: '', items: [{ name: 'Quit', hotkeyIdx: 0 }] },
    ],
    display: [
      { group: 'ACCOUNTING', items: [{ name: 'Trial Balance', hotkeyIdx: 0 }, { name: 'Cash Flow', hotkeyIdx: 0 }, { name: 'Funds Flow', hotkeyIdx: 0 }, { name: 'Bank Reconciliation', hotkeyIdx: 0 }, { name: 'Account Books', hotkeyIdx: 0 }, { name: 'Statements of Accounts', hotkeyIdx: 0 }, { name: 'Registers', hotkeyIdx: 0 }] },
      { group: 'INVENTORY', items: [{ name: 'Inventory Books', hotkeyIdx: 0 }, { name: 'Statements of Inventory', hotkeyIdx: 4 }] },
      { group: 'STATUTORY', items: [{ name: 'GSTR-1 (Outward Supplies)', hotkeyIdx: 0 }, { name: 'GSTR-3B (Summary Return)', hotkeyIdx: 0 }, { name: 'GST Tax Rate Summary', hotkeyIdx: 0 }] },
      { group: '', items: [{ name: 'Quit', hotkeyIdx: 0 }] },
    ],
    creation: [
      { group: 'Accounting Masters', items: [{ name: 'Group', hotkeyIdx: 0 }, { name: 'Ledger', hotkeyIdx: 0 }, { name: 'Currency', hotkeyIdx: 0 }, { name: 'Voucher Type', hotkeyIdx: 0 }] },
      { group: 'Inventory Masters', items: [{ name: 'Stock Group', hotkeyIdx: 0 }, { name: 'Stock Category', hotkeyIdx: 6 }, { name: 'Stock Item', hotkeyIdx: 6 }, { name: 'Unit', hotkeyIdx: 0 }, { name: 'Location', hotkeyIdx: 0 }] },
      { group: 'Payroll Masters', items: [{ name: 'Employee', hotkeyIdx: 0 }, { name: 'Salary Component', hotkeyIdx: 7 }] },
      { group: '', items: [{ name: 'Quit', hotkeyIdx: 0 }] },
    ],
    alteration: [
      { group: 'Accounting Masters', items: [{ name: 'Group', hotkeyIdx: 0 }, { name: 'Ledger', hotkeyIdx: 0 }, { name: 'Currency', hotkeyIdx: 0 }, { name: 'Voucher Type', hotkeyIdx: 0 }] },
      { group: 'Inventory Masters', items: [{ name: 'Stock Group', hotkeyIdx: 0 }, { name: 'Stock Category', hotkeyIdx: 6 }, { name: 'Stock Item', hotkeyIdx: 6 }, { name: 'Unit', hotkeyIdx: 0 }, { name: 'Location', hotkeyIdx: 0 }] },
      { group: 'Payroll Masters', items: [{ name: 'Employee', hotkeyIdx: 0 }, { name: 'Salary Component', hotkeyIdx: 7 }] },
      { group: '', items: [{ name: 'Quit', hotkeyIdx: 0 }] },
    ],
    accountsList: [
      { group: 'Accounting Masters', items: [{ name: 'Group', hotkeyIdx: 0 }, { name: 'Ledger', hotkeyIdx: 0 }, { name: 'Currency', hotkeyIdx: 0 }, { name: 'Voucher Type', hotkeyIdx: 0 }] },
      { group: 'Inventory Masters', items: [{ name: 'Stock Group', hotkeyIdx: 0 }, { name: 'Stock Category', hotkeyIdx: 6 }, { name: 'Stock Item', hotkeyIdx: 6 }, { name: 'Unit', hotkeyIdx: 0 }, { name: 'Location', hotkeyIdx: 0 }] },
      { group: 'Payroll Masters', items: [{ name: 'Employee', hotkeyIdx: 0 }] },
      { group: '', items: [{ name: 'Quit', hotkeyIdx: 0 }] },
    ],
    creation_ledger: [{ group: '', items: [] }],
    payroll: [
      { group: 'PAYROLL', items: [{ name: 'Salary Processing', hotkeyIdx: 0 }, { name: 'Payslips', hotkeyIdx: 0 }, { name: 'Payroll Reports', hotkeyIdx: 8 }, { name: 'Salary Structure', hotkeyIdx: 10 }, { name: 'Deductions & Allowances', hotkeyIdx: 0 }] },
      { group: '', items: [{ name: 'Quit', hotkeyIdx: 0 }] },
    ],
    employees: [
      { group: 'EMPLOYEES', items: [{ name: 'Employee List', hotkeyIdx: 9 }, { name: 'Add Employee', hotkeyIdx: 0 }, { name: 'Employee Details', hotkeyIdx: 9 }, { name: 'Attendance Management', hotkeyIdx: 0 }, { name: 'Leave Management', hotkeyIdx: 6 }, { name: 'Loan Management', hotkeyIdx: 0 }] },
      { group: '', items: [{ name: 'Quit', hotkeyIdx: 0 }] },
    ],
    ledgers: [
      { group: 'LEDGERS', items: [{ name: 'Cash', hotkeyIdx: 0 }, { name: 'Bank Account', hotkeyIdx: 0 }, { name: 'Sundry Debtors', hotkeyIdx: 0 }, { name: 'Sundry Creditors', hotkeyIdx: 0 }] },
      { group: '', items: [{ name: 'Quit', hotkeyIdx: 0 }] },
    ],
    vouchers: [
      { group: '', items: [{ name: 'Create', align: 'right', hotkeyIdx: -1 }, { name: 'Cash', hotkeyIdx: -1 }] },
    ],
    daybook: [
      { group: '', items: [] },
    ],
    balancesheet: [
      { group: '', items: [] }
    ],
    groupsummary_currentassets: [
      { group: '', items: [] }
    ],
    groupsummary_default: [
      { group: '', items: [{ name: 'No entries found', debit: '', credit: '', hotkeyIdx: -1 }] }
    ],
    display_trialbalance: [{ group: '', items: [{ name: 'Detailed View', hotkeyIdx: 0 }, { name: 'Condensed View', hotkeyIdx: 0 }, { name: 'Quit', hotkeyIdx: 0 }] }],
    display_daybook: [{ group: '', items: [{ name: 'Current Date', hotkeyIdx: 0 }, { name: 'Quit', hotkeyIdx: 0 }] }],
    display_cashflow: [{ group: '', items: [{ name: 'Daily', hotkeyIdx: 0 }, { name: 'Monthly', hotkeyIdx: 0 }, { name: 'Quit', hotkeyIdx: 0 }] }],
    display_fundsflow: [{ group: '', items: [{ name: 'Monthly', hotkeyIdx: 0 }, { name: 'Quit', hotkeyIdx: 0 }] }],
    display_accountbooks: [{ group: '', items: [{ name: 'Cash/Bank Book(s)', hotkeyIdx: 0 }, { name: 'Ledger', hotkeyIdx: 0 }, { name: 'Group Summary', hotkeyIdx: 0 }, { name: 'Group Vouchers', hotkeyIdx: 0 }, { name: 'Sales Register', hotkeyIdx: 0 }, { name: 'Purchase Register', hotkeyIdx: 0 }, { name: 'Journal Register', hotkeyIdx: 0 }, { name: 'Quit', hotkeyIdx: 0 }] }],
    display_statementsofaccounts: [{ group: '', items: [{ name: 'Outstanding', hotkeyIdx: 0 }, { name: 'Party Register', hotkeyIdx: 0 }, { name: 'Summary', hotkeyIdx: 0 }, { name: 'Quit', hotkeyIdx: 0 }] }],
    display_registers: [{ group: '', items: [{ name: 'Sales Register', hotkeyIdx: 0 }, { name: 'Purchase Register', hotkeyIdx: 0 }, { name: 'Journal Register', hotkeyIdx: 0 }, { name: 'Receipt Register', hotkeyIdx: 0 }, { name: 'Payment Register', hotkeyIdx: 1 }, { name: 'Contra Register', hotkeyIdx: 0 }, { name: 'Quit', hotkeyIdx: 0 }] }],
    quotation_list: [{ group: 'QUOTATIONS', items: [{ name: 'Create Quotation', hotkeyIdx: 0 }, { name: 'Alter Quotation', hotkeyIdx: 0 }, { name: 'Quit', hotkeyIdx: 0 }] }],
    display_inventorybooks: [{ group: '', items: [{ name: 'Stock Overview', hotkeyIdx: 6 }, { name: 'Stock Flow', hotkeyIdx: 6 }, { name: 'Quit', hotkeyIdx: 0 }] }],
    display_statementsofinventory: [{ group: '', items: [{ name: 'Check Stock', hotkeyIdx: 0 }, { name: 'Cost Calculator', hotkeyIdx: 0 }, { name: 'Pending Sales Orders', hotkeyIdx: 8 }, { name: 'Pending Purchase Orders', hotkeyIdx: 8 }, { name: 'Low Stock Alert', hotkeyIdx: 0 }, { name: 'Quit', hotkeyIdx: 0 }] }],
    alteration_group: [{ group: '', items: [{ name: 'Create', hotkeyIdx: 0 }, { name: 'Bank Accounts', hotkeyIdx: 0 }, { name: 'Cash-in-Hand', hotkeyIdx: 0 }, { name: 'Current Liabilities', hotkeyIdx: 0 }, { name: 'Fixed Assets', hotkeyIdx: 0 }, { name: 'Sundry Creditors', hotkeyIdx: 0 }, { name: 'Sundry Debtors', hotkeyIdx: 0 }, { name: 'Quit', hotkeyIdx: 0 }] }],
    alteration_ledger: [{ group: '', items: [{ name: 'Create', hotkeyIdx: 0 }, { name: 'Quit', hotkeyIdx: 0 }] }],
    alteration_currency: [{ group: '', items: [{ name: 'Create', hotkeyIdx: 0 }, { name: '₹', hotkeyIdx: 0 }, { name: '$', hotkeyIdx: 0 }, { name: '€', hotkeyIdx: 0 }, { name: '£', hotkeyIdx: 0 }, { name: 'Quit', hotkeyIdx: 0 }] }],
    alteration_vouchertype: [{ group: '', items: [{ name: 'Create', hotkeyIdx: 0 }, { name: 'Contra', hotkeyIdx: 0 }, { name: 'Journal', hotkeyIdx: 0 }, { name: 'Payment', hotkeyIdx: 0 }, { name: 'Purchase', hotkeyIdx: 0 }, { name: 'Receipt', hotkeyIdx: 0 }, { name: 'Sales', hotkeyIdx: 0 }, { name: 'Quit', hotkeyIdx: 0 }] }],
    alteration_stockgroup: [{ group: '', items: [{ name: 'Create', hotkeyIdx: 0 }, { name: 'Electronics', hotkeyIdx: 0 }, { name: 'Furniture', hotkeyIdx: 0 }, { name: 'Stationery', hotkeyIdx: 0 }, { name: 'Raw Materials', hotkeyIdx: 0 }, { name: 'Quit', hotkeyIdx: 0 }] }],
    alteration_stockcategory: [{ group: '', items: [{ name: 'Create', hotkeyIdx: 0 }, { name: 'Laptops', hotkeyIdx: 0 }, { name: 'Mobiles', hotkeyIdx: 0 }, { name: 'Office Chairs', hotkeyIdx: 0 }, { name: 'Pens', hotkeyIdx: 0 }, { name: 'Quit', hotkeyIdx: 0 }] }],
    alteration_stockitem: [{ group: '', items: [{ name: 'Create', hotkeyIdx: 0 }, { name: 'Dell XPS 13', hotkeyIdx: 0 }, { name: 'iPhone 14', hotkeyIdx: 0 }, { name: 'Executive Chair', hotkeyIdx: 0 }, { name: 'Parker Pen', hotkeyIdx: 0 }, { name: 'Quit', hotkeyIdx: 0 }] }],
    alteration_unit: [{ group: '', items: [{ name: 'Create', hotkeyIdx: 0 }, { name: 'Nos', hotkeyIdx: 0 }, { name: 'Kgs', hotkeyIdx: 0 }, { name: 'Ltrs', hotkeyIdx: 0 }, { name: 'Pcs', hotkeyIdx: 0 }, { name: 'Quit', hotkeyIdx: 0 }] }],
    alteration_location: [{ group: '', items: [{ name: 'Create', hotkeyIdx: 0 }, { name: 'Main Godown', hotkeyIdx: 0 }, { name: 'Mumbai Branch', hotkeyIdx: 0 }, { name: 'Delhi Branch', hotkeyIdx: 0 }, { name: 'Quit', hotkeyIdx: 0 }] }],
    accountsList_group: [
      {
        group: '',
        items: [
          { name: 'Branch / Divisions', hotkeyIdx: -1, indent: 0 }, { name: 'Capital Account', hotkeyIdx: -1, indent: 0 }, { name: 'Reserves & Surplus', hotkeyIdx: -1, indent: 1 },
          { name: 'Current Assets', hotkeyIdx: -1, indent: 0 }, { name: 'Bank Accounts', hotkeyIdx: -1, indent: 1 }, { name: 'Cash-in-Hand', hotkeyIdx: -1, indent: 1 }, { name: 'Deposits (Asset)', hotkeyIdx: -1, indent: 1 }, { name: 'Loans & Advances (Asset)', hotkeyIdx: -1, indent: 1 }, { name: 'Stock-in-Hand', hotkeyIdx: -1, indent: 1 }, { name: 'Sundry Debtors', hotkeyIdx: -1, indent: 1 },
          { name: 'Current Liabilities', hotkeyIdx: -1, indent: 0 }, { name: 'Duties & Taxes', hotkeyIdx: -1, indent: 1 }, { name: 'Provisions', hotkeyIdx: -1, indent: 1 }, { name: 'Sundry Creditors', hotkeyIdx: -1, indent: 1 },
          { name: 'Direct Expenses', hotkeyIdx: -1, indent: 0 }, { name: 'Direct Incomes', hotkeyIdx: -1, indent: 0 }, { name: 'Fixed Assets', hotkeyIdx: -1, indent: 0 }, { name: 'Indirect Expenses', hotkeyIdx: -1, indent: 0 }, { name: 'Indirect Incomes', hotkeyIdx: -1, indent: 0 }, { name: 'Investments', hotkeyIdx: -1, indent: 0 },
          { name: 'Loans (Liability)', hotkeyIdx: -1, indent: 0 }, { name: 'Bank OD A/c', hotkeyIdx: -1, indent: 1 }, { name: 'Secured Loans', hotkeyIdx: -1, indent: 1 }, { name: 'Unsecured Loans', hotkeyIdx: -1, indent: 1 },
          { name: 'Misc. Expenses (ASSET)', hotkeyIdx: -1, indent: 0 }, { name: 'Purchase Accounts', hotkeyIdx: -1, indent: 0 }, { name: 'Sales Accounts', hotkeyIdx: -1, indent: 0 }, { name: 'Suspense A/c', hotkeyIdx: -1, indent: 0 },
          { name: 'Quit', hotkeyIdx: 0, indent: 0 }
        ]
      }
    ],
    accountsList_ledger: [{ group: '', items: [{ name: 'Quit', hotkeyIdx: 0, indent: 0 }] }],
    accountsList_currency: [{ group: '', items: [{ name: '₹', hotkeyIdx: -1, indent: 0 }, { name: '$', hotkeyIdx: -1, indent: 0 }, { name: '€', hotkeyIdx: -1, indent: 0 }, { name: '£', hotkeyIdx: -1, indent: 0 }, { name: 'Quit', hotkeyIdx: 0, indent: 0 }] }],
    accountsList_vouchertype: [{ group: '', items: [{ name: 'Contra', hotkeyIdx: -1, indent: 0 }, { name: 'Journal', hotkeyIdx: -1, indent: 0 }, { name: 'Payment', hotkeyIdx: -1, indent: 0 }, { name: 'Purchase', hotkeyIdx: -1, indent: 0 }, { name: 'Receipt', hotkeyIdx: -1, indent: 0 }, { name: 'Sales', hotkeyIdx: -1, indent: 0 }, { name: 'Quit', hotkeyIdx: 0, indent: 0 }] }],
    accountsList_stockgroup: [{ group: '', items: [{ name: 'Electronics', hotkeyIdx: -1, indent: 0 }, { name: 'Furniture', hotkeyIdx: -1, indent: 0 }, { name: 'Stationery', hotkeyIdx: -1, indent: 0 }, { name: 'Quit', hotkeyIdx: 0, indent: 0 }] }],
    accountsList_stockcategory: [{ group: '', items: [{ name: 'Laptops', hotkeyIdx: -1, indent: 0 }, { name: 'Mobiles', hotkeyIdx: -1, indent: 0 }, { name: 'Office Chairs', hotkeyIdx: -1, indent: 0 }, { name: 'Pens', hotkeyIdx: -1, indent: 0 }, { name: 'Quit', hotkeyIdx: 0, indent: 0 }] }],
    accountsList_stockitem: [{ group: '', items: [{ name: 'Dell XPS 13', hotkeyIdx: -1, indent: 0 }, { name: 'iPhone 14', hotkeyIdx: -1, indent: 0 }, { name: 'Executive Chair', hotkeyIdx: -1, indent: 0 }, { name: 'Parker Pen', hotkeyIdx: -1, indent: 0 }, { name: 'Quit', hotkeyIdx: 0, indent: 0 }] }],
    accountsList_unit: [{ group: '', items: [{ name: 'Nos', hotkeyIdx: -1, indent: 0 }, { name: 'Kgs', hotkeyIdx: -1, indent: 0 }, { name: 'Ltrs', hotkeyIdx: -1, indent: 0 }, { name: 'Pcs', hotkeyIdx: -1, indent: 0 }, { name: 'Quit', hotkeyIdx: 0, indent: 0 }] }],
    accountsList_location: [{ group: '', items: [{ name: 'Main Godown', hotkeyIdx: -1, indent: 0 }, { name: 'Mumbai Branch', hotkeyIdx: -1, indent: 0 }, { name: 'Delhi Branch', hotkeyIdx: -1, indent: 0 }, { name: 'Quit', hotkeyIdx: 0, indent: 0 }] }],
  },
  sidebarShortcuts: [
    { shortcut: 'F2', label: 'Date', tooltip: 'Change Current Date (F2)' },
    { shortcut: 'F3', label: 'Company', tooltip: 'Select / Change Company (F3)', active: true },
    { shortcut: 'F4', label: 'Contra', tooltip: 'Contra Voucher (F4)' },
    { shortcut: 'F5', label: 'Payment', tooltip: 'Payment Voucher (F5)' },
    { shortcut: 'F6', label: 'Receipt', tooltip: 'Receipt Voucher (F6)' },
    { shortcut: 'F7', label: 'Journal', tooltip: 'Journal Voucher (F7)' },
    { shortcut: 'F8', label: 'Sales', tooltip: 'Sales Voucher (F8)' },
    { shortcut: 'F9', label: 'Purchase', tooltip: 'Purchase Voucher (F9)' },
    { shortcut: 'F10', label: 'Issues & Suggestions', tooltip: 'Issues & Suggestions Center (F10)' },
    { spacer: true },
    { shortcut: 'B', label: 'Bin Box', tooltip: 'Deleted Vouchers Bin Box (B)' }
  ],
  companyList: [],
  labels: {
    breadcrumbs: {
      main: 'Business Overview', display: 'Display More Reports', creation: 'Master Creation',
      payroll: 'Payroll', accountsList: 'Accounts List',
      ledgers: 'Ledgers', alteration: 'Master Alteration', vouchers: 'Accounting Voucher Creation',
      daybook: 'Day Book', balancesheet: 'Balance Sheet',
      creation_group: 'Group Creation', creation_ledger: 'Ledger Creation', creation_currency: 'Currency Creation',
      creation_vouchertype: 'Voucher Type Creation', creation_stockgroup: 'Stock Group Creation',
      creation_stockcategory: 'Stock Category Creation', creation_stockitem: 'Stock Item Creation',
      creation_unit: 'Unit Creation', creation_location: 'Location Creation',
      alteration_group: 'Group', alteration_ledger: 'Ledger', alteration_currency: 'Currency', 
      alteration_vouchertype: 'Voucher Type', alteration_stockgroup: 'Stock Group', 
      alteration_stockcategory: 'Stock Category', alteration_stockitem: 'Stock Item', 
      alteration_unit: 'Unit', alteration_location: 'Location',
      accountsList_group: 'Group', accountsList_ledger: 'Ledger', accountsList_currency: 'Currency', 
      accountsList_vouchertype: 'Voucher Type', accountsList_stockgroup: 'Stock Group', 
      accountsList_stockcategory: 'Stock Category', accountsList_stockitem: 'Stock Item', 
      accountsList_unit: 'Unit', accountsList_location: 'Location',
      display_trialbalance: 'Trial Balance', display_cashflow: 'Cash Flow',
      display_fundsflow: 'Funds Flow', display_accountbooks: 'Account Books', display_statementsofaccounts: 'Statements of Accounts',
      display_registers: 'Registers', display_inventorybooks: 'Inventory Books', display_statementsofinventory: 'Statements of Inventory',
      display_stocksummary: 'Stock Overview', display_stockmovement: 'Stock Flow',
      display_outstanding: 'Outstanding', display_statistics: 'Summary',
      display_stockquery: 'Check Stock', display_costestimation: 'Cost Calculator',
      display_salesorderoutstanding: 'Pending Sales Orders', display_purchaseorderoutstanding: 'Pending Purchase Orders',
      display_reorderstatus: 'Low Stock Alert',
      display_ledgers: 'List of Ledgers',
      creation_company: 'Company Creation',
      alteration_company: 'Company Alteration',
      select_company: 'Select Company',
      delete_company: 'Delete Company',
      backup_company: 'Backup Company',
      restore_company: 'Restore Company',
      profitloss: 'Profit & Loss A/c',
      ledgervouchers: 'Ledger Vouchers',
      groupsummary_default: 'Group Summary',
      groupsummary_currentassets: 'Group Summary',
      groupsummary_capitalaccount: 'Group Summary',
      groupsummary_loansliability: 'Group Summary',
      groupsummary_currentliabilities: 'Group Summary',
      groupsummary_profitlossac: 'Group Summary',
      alter_ledger_form: 'Ledger Alteration',
      alter_voucher_form: 'Voucher Alteration',
      register_summary_receipt: 'Receipt Register',
      register_summary_payment: 'Payment Register',
      register_summary_sales: 'Sales Register',
      register_summary_purchase: 'Purchase Register',
      register_summary_journal: 'Journal Register',
      register_summary_contra: 'Contra Register',
      voucher_register_receipt: 'Voucher Register',
      voucher_register_payment: 'Voucher Register',
      voucher_register_sales: 'Voucher Register',
      voucher_register_purchase: 'Voucher Register',
      voucher_register_journal: 'Voucher Register',
      voucher_register_contra: 'Voucher Register',
      creation_employee: 'Employee Creation',
      alter_employee_form: 'Employee Alteration',
      employees: 'Employee List',
      payroll_attendance: 'Attendance Management',
      payroll_leave: 'Leave Management',
      payroll_loans: 'Loan Management',
      payroll_processing: 'Salary Processing',
      payroll_summary: 'Salary Register',
      payslip: 'Payslip',
      import_bank: 'Bank Statement Import',
      import_invoice: 'Invoice Import'
    },
    modalTitles: {
      'group': 'List of Groups', 'ledger': 'List of Ledgers', 'currency': 'List of Currencies',
      'vouchertype': 'List of Voucher Types', 'stockgroup': 'List of Stock Groups', 'stockcategory': 'List of Stock Categories',
      'stockitem': 'List of Stock Items', 'unit': 'List of Units', 'location': 'List of Locations',
      'trialbalance': 'Trial Balance', 'cashflow': 'Cash Flow', 'fundsflow': 'Funds Flow',
      'accountbooks': 'List of Account Books', 'statementsofaccounts': 'Statements of Accounts', 'registers': 'List of Registers',
      'inventorybooks': 'Inventory Books', 'statementsofinventory': 'Statements of Inventory',
    },
    fullScreenTitles: {
      'group': 'Groups', 'ledger': 'Ledgers', 'currency': 'Currencies', 'vouchertype': 'Voucher Types',
      'stockgroup': 'Stock Groups', 'stockcategory': 'Stock Categories', 'stockitem': 'Stock Items',
      'unit': 'Units', 'location': 'Locations',
      'display_ledgers': 'List of Ledgers',
      'ledgers': 'List of Ledgers'
    }
  }
};

// Aliases
APP_CONFIG.gatewayMenus.alteration = APP_CONFIG.gatewayMenus.creation;
APP_CONFIG.gatewayMenus.accountsList = APP_CONFIG.gatewayMenus.creation;

['capitalaccount', 'loansliability', 'currentliabilities', 'profitlossac'].forEach(slug => {
  APP_CONFIG.gatewayMenus[`groupsummary_${slug}`] = APP_CONFIG.gatewayMenus.groupsummary_default;
});

['ledger', 'currency', 'vouchertype', 'stockgroup', 'stockcategory', 'stockitem', 'unit', 'location'].forEach(slug => {
  APP_CONFIG.gatewayMenus[`accountsList_${slug}`] = APP_CONFIG.gatewayMenus[`alteration_${slug}`];
});